export const setItem = (item, value) => window.sessionStorage.setItem(item, JSON.stringify(value));

export const getItem = (item, defaultValue = null) => {
  const value = window.sessionStorage.getItem(item);
  return value ? JSON.parse(value) : defaultValue;
};